import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import ReactDOM from 'react-dom'
import './styles/index.scss'
import App from './main/App'
import './config/MomentConfig'
import { flavour } from './config'
import { AuthContextProvider } from './auth/AuthContextProvider'
import { PusherProvider } from './pusher/PusherContext'
import { AppStateProvider } from './main/AppState'
import { IntlProvider } from 'react-intl'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { CookiePopup } from './cookies/popup'
import { AppConfigurationProvider } from './shared/contexts/AppConfiguration'
import { ReportingConfigurationProvider } from './shared/contexts/ReportingConfiguration'
import { loadConfigurationFromOrigin } from './configLoader.ts'
import * as Sentry from '@sentry/react'
import packageJson from '../package.json'

const onRedirectCallback = (appState) => {
  window.location.replace(appState && appState.targetUrl ? appState.targetUrl : '/dashboard')
}

const onIntlError = (error) => {
  if (process.env.NODE_ENV !== 'production') {
    console.warn(error)
  }
}

loadConfigurationFromOrigin()
  .then(() => {
    Sentry.init({
      dsn: "https://d7b17c10512ca10929688fb4b6ded627@o4508845931495424.ingest.de.sentry.io/4508845974159440",
      environment: window.__env__.TENANT_ID,
      release: packageJson.version,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      tracesSampleRate: window.__env__.TENANT_ID === 'local' ? 1.0 : 0.25,
      // Allow localhost and deployment domains 
      tracePropagationTargets: [window.__env__.SERVER],
      replaysSessionSampleRate: window.__env__.TENANT_ID === 'local' ? 1.0 : 0.25,
      replaysOnErrorSampleRate: 1.0,
    }
    )
    ReactDOM.render(
      <IntlProvider locale="en" messages={flavour.messages} onError={onIntlError}>
        <AppConfigurationProvider>
          <AuthContextProvider redirect_uri={window.location.origin} onRedirectCallback={onRedirectCallback}>
            <PusherProvider>
              <AppStateProvider>
                <ReportingConfigurationProvider>
                  <App />
                  <ToastContainer />
                  <CookiePopup />
                </ReportingConfigurationProvider>
              </AppStateProvider>
            </PusherProvider>
          </AuthContextProvider>
        </AppConfigurationProvider>
      </IntlProvider>
      ,
      document.getElementById('root')
    )
  })
  .catch((error) => {
    console.log(error)
    console.log('Failed to load a configuration')
  })
